import { render, staticRenderFns } from "./StartupPage.vue?vue&type=template&id=6e216ad9"
import script from "./StartupPage.vue?vue&type=script&lang=ts"
export * from "./StartupPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports